import React, { useState } from "react";
import {
  Box,
  Card,
  Tabs,
  Tab,
  LinearProgress,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";
import { KeyUri, config } from "../key";
import useMediaQuery from "@mui/material/useMediaQuery";

import { BasicInformationSection } from "./BasicInformationSection";
import { LocationSection } from "./LocationSection";
import { ContactSection } from "./ContactSection";
import { AmenitiesSection } from "./AmenitiesSection";
import AccommodationsSection from "./AccomodationSection";
import { PoliciesSection } from "./policiesSection";
import { PropertyStatusCards } from "./Propertystatuscards";

import { toast } from "react-toastify";

const vendorToken = localStorage.getItem("vendorToken")
  ? localStorage.getItem("vendorToken")
  : null;
//console.log("vendor token", vendorToken);

export function PropertyForm() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [activeTab, setActiveTab] = useState("basic");
  const [formData, setFormData] = useState({
    address: "",
    city: "",
    state: "",
    pincode: "",
    landmark: "",
    mapShareLink: "",
    amenities: {
      general: [],
      recreational: [],
      dining: [],
      services: [],
    },
    policies: {
      cancellation: "",
      petPolicy: "not-allowed",
      smokingPolicy: "not-allowed",
      childPolicy: "",
    },
    accommodations: [],
    languages: [],
    accessibility: [],
    currency: "INR",
    petPolicy: "not-allowed",
    smokingPolicy: "not-allowed",
    status: "draft",
  });
  const [errors, setErrors] = useState({});
  // bump after a save/submit so the status cards re-fetch their counts
  const [statsRefreshKey, setStatsRefreshKey] = useState(0);

  const TAB_ORDER = [
    "basic",
    "location",
    "contact",
    "accommodations",
    "amenities",
    "policies",
  ];

  const validateField = (field, value) => {
    const errors = {};

    switch (field) {
      case "propertyName":
        if (!value?.trim()) errors.propertyName = "Property name is required";
        else if (value.trim().length < 3)
          errors.propertyName = "Property name must be at least 3 characters";
        else if (value.trim().length > 100)
          errors.propertyName = "Property name cannot exceed 100 characters";
        break;

      case "description":
        if (!value?.trim()) errors.description = "Description is required";
        else if (value.trim().length < 50)
          errors.description = "Description must be at least 50 characters";
        else if (value.trim().length > 2000)
          errors.description = "Description cannot exceed 2000 characters";
        break;

      case "propertyType":
        if (!value) errors.propertyType = "Property type is required";
        else if (
          ![
            "hotel",
            "homestay",
            "resort",
            "farmstay",
            "villa",
            "guesthouse",
            "cottage",
            "apartment",
            "hostel",
            "dormitory",
          ].includes(value)
        )
          errors.propertyType = "Invalid property type";
        break;

      case "checkInTime":
      case "checkOutTime":
        if (!value)
          errors[field] = `${field.replace("Time", " time")} is required`;
        else if (!/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value))
          errors[field] = "Please provide valid time format (HH:MM)";
        break;

      case "pincode":
        if (!value?.trim()) errors.pincode = "Pincode is required";
        else if (!/^\d{6}$/.test(value))
          errors.pincode = "Please provide a valid 6-digit pincode";
        break;

      case "contactPerson":
        if (!value?.trim())
          errors.contactPerson = "Contact person name is required";
        else if (value.trim().length < 3)
          errors.contactPerson = "Name must be at least 3 characters";
        else if (value.trim().length > 50)
          errors.contactPerson = "Name cannot exceed 50 characters";
        break;

      case "contactEmail":
        if (!value?.trim()) errors.contactEmail = "Email is required";
        else if (!/^\S+@\S+\.\S+$/.test(value))
          errors.contactEmail = "Please provide a valid email";
        break;

      case "contactPhone":
        if (!value?.trim()) errors.contactPhone = "Phone number is required";
        else if (!/^\+?\d{10}$/.test(value.replace(/[\s\-\(\)]/g, ""))) {

          const cleanPhone = value.replace(/[\s\-\(\)\+]/g, "");
          if (cleanPhone.length !== 10) {
            errors.contactPhone = `Phone number must be exactly 10 digits (you entered ${cleanPhone.length})`;
          } else {
            errors.contactPhone = "Please provide a valid phone number";
          }
        }
        break;

      case "alternatePhone":
        if (value?.trim()) {
          const cleanPhone = value.replace(/[\s\-\(\)\+]/g, "");
          if (cleanPhone.length !== 10) {
            errors.alternatePhone = `Alternate phone must be exactly 10 digits (you entered ${cleanPhone.length})`;
          }
        }
        break;
    }

    return errors;
  };

 
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

   
    const fieldErrors = validateField(field, value);
    if (Object.keys(fieldErrors).length === 0 && errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    } else if (Object.keys(fieldErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...fieldErrors }));
    }
  };

 
  const validateForm = (scope = "all") => {
    const newErrors = {};

    const fieldsToValidate =
      scope === "all"
        ? [
            "propertyName",
            "propertyType",
            "description",
            "checkInTime",
            "checkOutTime",
            "address",
            "city",
            "state",
            "pincode",
            "contactPerson",
            "contactEmail",
            "contactPhone",
          ]
        : scope === "basic"
          ? [
              "propertyName",
              "propertyType",
              "description",
              "checkInTime",
              "checkOutTime",
            ]
          : scope === "location"
            ? ["address", "city", "state", "pincode"]
            : scope === "contact"
              ? ["contactPerson", "contactEmail", "contactPhone"]
              : [];

    fieldsToValidate.forEach((field) => {
      const fieldErrors = validateField(field, formData[field]);
      Object.assign(newErrors, fieldErrors);
    });

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys(newErrors).length === 0;
  };

 
  const nextTab = () => {
    const isValid = validateForm(activeTab);
    if (!isValid) {
      toast.error("Please fix errors on this step before continuing.");
      return;
    }
    const idx = TAB_ORDER.indexOf(activeTab);
    if (idx < TAB_ORDER.length - 1) setActiveTab(TAB_ORDER[idx + 1]);
  };

  const prevTab = () => {
    const idx = TAB_ORDER.indexOf(activeTab);
    if (idx > 0) setActiveTab(TAB_ORDER[idx - 1]);
  };

  /*const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };*/

 
  const handleApiError = (error, action = "submit") => {
    console.error(`Error ${action}ing property:`, error);
    let message = `Failed to ${action} property.`;
    let fieldErrors = {};

    if (error.response?.data) {
      const data = error.response.data;

      if (error.response.status === 400 && data.errors) {
       
        const fieldMap = {
          propertyName: "propertyName",
          propertyType: "propertyType",
          description: "description",
          checkInTime: "checkInTime",
          checkOutTime: "checkOutTime",
          "location.address": "address",
          "location.city": "city",
          "location.state": "state",
          "location.pincode": "pincode",
          "contact.person": "contactPerson",
          "contact.email": "contactEmail",
          "contact.phone": "contactPhone",
        };

        data.errors.forEach((err) => {
          const frontendField = fieldMap[err.field] || err.field;
          fieldErrors[frontendField] = err.message; 
        });

        setErrors((prev) => ({ ...prev, ...fieldErrors }));

        
        const errorTabs = {
          propertyName: "basic",
          propertyType: "basic",
          description: "basic",
          checkInTime: "basic",
          checkOutTime: "basic",
          address: "location",
          city: "location",
          state: "location",
          pincode: "location",
          contactPerson: "contact",
          contactEmail: "contact",
          contactPhone: "contact",
        };

        const firstErrorField = Object.keys(fieldErrors)[0];
        if (errorTabs[firstErrorField]) {
          setActiveTab(errorTabs[firstErrorField]);
          message = `${fieldErrors[firstErrorField]} - Please fix before continuing.`;
        } else {
          message = Object.values(fieldErrors).join(", ");
        }
      } else if (data.message) {
        message = data.message;
      }
    }

    toast.error(message);
  };

  const handleSaveDraft = async () => {
    if (!vendorToken) {
      toast.error("Authentication required. Please login.");
      return;
    }

    const draftData = { ...formData, status: "draft" };
    try {
      const response = await axios.post(
        KeyUri.BACKEND_URI + "/create-property",
        draftData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${vendorToken}`,
          },
        },
      );
     
      toast.success("Property saved as draft!", {
        description: "You can continue editing later.",
      });
      setStatsRefreshKey((k) => k + 1);
    } catch (error) {
      handleApiError(error, "save");
    }
  };

  
  const handleSubmit = async () => {
    if (!vendorToken) {
      toast.error("Authentication required. Please login.");
      return;
    }

    const isValid = validateForm("all");
    if (!isValid) {
      toast.error("Please fill all required fields");
      const errorKeys = Object.keys(errors);
      if (
        errorKeys.some((k) =>
          ["propertyName", "propertyType", "description"].includes(k),
        )
      )
        setActiveTab("basic");
      else if (
        errorKeys.some((k) =>
          ["address", "city", "state", "pincode"].includes(k),
        )
      )
        setActiveTab("location");
      else if (
        errorKeys.some((k) =>
          ["contactPerson", "contactEmail", "contactPhone"].includes(k),
        )
      )
        setActiveTab("contact");
      return;
    }

    if (formData.accommodations?.length === 0) {
      toast.error("Please add at least one accommodation type");
      setActiveTab("accommodations");
      return;
    }

    const submittedData = { ...formData, status: "pending" };
    try {
      const response = await axios.post(
        KeyUri.BACKEND_URI + "/create-property",
        submittedData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${vendorToken}`,
          },
        },
      );
     
      toast.success("Property submitted successfully!", {
        description: "Your property is now pending admin approval.",
      });
      setFormData({
        amenities: { general: [], recreational: [], dining: [], services: [] },
        accommodations: [],
        languages: [],
        accessibility: [],
        currency: "INR",
        petPolicy: "not-allowed",
        smokingPolicy: "not-allowed",
        status: "draft",
      });
      setErrors({});
      setActiveTab("basic");
      setStatsRefreshKey((k) => k + 1);
    } catch (error) {
      handleApiError(error, "submit");
    }
  };

  const getProgress = () => {
    let completed = 0;
    const total = 6; 

   
    if (formData.propertyName && formData.propertyType && formData.description)
      completed++;

    
    if (formData.address && formData.city && formData.state && formData.pincode)
      completed++;

    if (
      formData.contactPerson &&
      formData.contactEmail &&
      formData.contactPhone
    )
      completed++;

   
    if (formData.accommodations && formData.accommodations.length > 0)
      completed++;

   
    const hasAmenities =
      (formData.amenities?.general?.length || 0) +
        (formData.amenities?.recreational?.length || 0) +
        (formData.amenities?.dining?.length || 0) +
        (formData.amenities?.services?.length || 0) >
      0;
    if (hasAmenities) completed++;

    
    const hasPolicies =
      formData.policies?.cancellation ||
      (formData.languages && formData.languages.length > 0);
    if (hasPolicies) completed++;

    return (completed / total) * 100; 
  };

  return (
    <Box
      sx={{
        my: 3,
        px: { xs: 1, sm: 2, md: 0 }, 
      }}
    >
      <Box sx={{ maxWidth: 900, mx: "auto", mb: 3 }}>
        <PropertyStatusCards compact refreshKey={statsRefreshKey} />
      </Box>

      <Card
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
          width: { xs: "100%", sm: "auto" },
          maxWidth: 900,
          mx: "auto",
        }}
      >
        <Box
          sx={{
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
              justifyContent: "space-between",
              mb: 1,
              gap: 0.5,
            }}
          >
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{ fontSize: { xs: "1.15rem", sm: "1.25rem" } }}
            >
              Property Registration Progress
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {Math.round(getProgress())}% Complete
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={getProgress()}
            sx={{ height: 8, borderRadius: 1 }}
          />
        </Box>

        <Tabs
          value={activeTab}
          onChange={(e, val) => setActiveTab(val)}
          variant={isMobile ? "scrollable" : "standard"}
          scrollButtons={isMobile ? false : "auto"}
          aria-label="property form tabs"
          sx={{
            mb: 4,
            "& .MuiTab-root": {
              fontSize: { xs: "0.7rem", sm: "0.8rem" },
              minWidth: isMobile ? 80 : "auto",
              paddingX: { xs: 1, sm: 2 },
            },
          }}
        >
          <Tab label="Basic Info" value="basic" />
          <Tab label="Location" value="location" />
          <Tab label="Contact" value="contact" />
          <Tab label="Rooms" value="accommodations" />
          <Tab label="Amenities" value="amenities" />
          <Tab label="Policies" value="policies" />
        </Tabs>

        {activeTab === "basic" && (
          <BasicInformationSection
            formData={formData}
            onChange={handleChange}
            errors={errors}
          />
        )}
        {activeTab === "location" && (
          <LocationSection
            formData={formData}
            onChange={handleChange}
            errors={errors}
          />
        )}
        {activeTab === "contact" && (
          <ContactSection
            formData={formData}
            onChange={handleChange}
            errors={errors}
          />
        )}
        {activeTab === "accommodations" && (
          <AccommodationsSection
            formData={formData}
            onChange={handleChange}
            errors={errors}
          />
        )}
        {activeTab === "amenities" && (
          <AmenitiesSection
            formData={formData}
            onChange={handleChange}
            errors={errors}
          />
        )}
        {activeTab === "policies" && (
          <PoliciesSection
            formData={formData}
            onChange={handleChange}
            errors={errors}
          />
        )}

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{ mt: 4, pt: 3, borderTop: "1px solid #ddd" }}
        >
          <Button
            variant="outlined"
            onClick={handleSaveDraft}
            startIcon={<SaveIcon />}
          >
            Save as Draft
          </Button>

          {activeTab !== "basic" && (
            <Button variant="outlined" onClick={prevTab}>
              Back
            </Button>
          )}

          {activeTab !== "policies" && (
            <Button variant="contained" onClick={nextTab}>
              Next
            </Button>
          )}

          {activeTab === "policies" && (
            <Button
              variant="contained"
              onClick={handleSubmit}
              startIcon={<SendIcon />}
              sx={{ flexGrow: 1 }}
            >
              Submit for Approval
            </Button>
          )}
        </Stack>
      </Card>
    </Box>
  );
}